export function formatValue(
  value: number,
  format: 'number' | 'percent' | 'currency',
  prefix?: string,
  suffix?: string,
): string {
  let formatted: string;

  switch (format) {
    case 'percent':
      formatted = `${(value * 100).toFixed(1)}%`;
      break;
    case 'currency':
      formatted = `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      break;
    default: {
      if (Math.abs(value) >= 1_000_000) {
        formatted = `${(value / 1_000_000).toFixed(1)}M`;
      } else if (Math.abs(value) >= 1_000) {
        formatted = `${(value / 1_000).toFixed(1)}K`;
      } else {
        formatted = value.toLocaleString('en-US');
      }
      break;
    }
  }

  const parts: string[] = [];
  if (prefix) parts.push(prefix);
  parts.push(formatted);
  if (suffix) parts.push(suffix);

  return parts.join('');
}
